import { FadeIn } from '../components/AnimateIn'
import ContactInfo from '../components/ContactInfo'
import Hero from '../components/Hero'
import Page from '../components/Page'
import Section from '../components/Section'
import { Text } from '../components/Text'

export default function Contact() {
  return (
    <Page>
      <Hero title='Contact Us' image='Contact' className='max-h-[600px] min-h-[600px]'>
        <div className='flex flex-1'>
          <Text.BodyLarge>
            <p>
              If you are seeking fellowship with a local assembly, want to learn more about the Lord
              Jesus Christ, or wish to study the Bible, we warmly invite you to join one of our
              weekly gatherings. Feel free to reach out to any of our Elders, Deacons for more
              information or guidance.
            </p>
          </Text.BodyLarge>
        </div>
      </Hero>
      <div className='flex flex-col lg:flex-row flex-1'>
        <div className='flex flex-col md:flex-row lg:flex-col gap-[64px] lg:gap-[96px] px-0 py-[64px] lg:py-[120px] transition-all'>
          <div className='flex flex-col gap-[44px] px-[32px] md:px-[64px] lg:px-[120px] transition-all flex-nowrap flex-1 lg:flex-grow-0'>
            <FadeIn delay={0.2}>
              <Text.H2>Write to Us</Text.H2>
            </FadeIn>
            <FadeIn delay={0.4}>
              <Text.Body className='text-nowrap'>
                <p>The Brethren Assembly Dubai</p>
                <p>Holy Trinity Church</p>
                <p>Opp. to Iranian Club</p>
                <p>Oud Metha Road</p>
                <p>Dubai, UAE</p>
              </Text.Body>
            </FadeIn>
          </div>
          <div className='bg-neutral-300 w-full h-[1px] md:hidden' />
          <div className='flex flex-col gap-[44px] px-[32px] lg:px-[120px] transition-all flex-1'>
            <FadeIn delay={0.6}>
              <Text.H2>Email</Text.H2>
            </FadeIn>
            <FadeIn delay={0.8}>
              <a href='mailto:info@dubaibrethren.com' className='text-[#007AFF] hover:underline'>
                info@dubaibrethren.com
              </a>
            </FadeIn>
          </div>
        </div>
        <div className='flex flex-col border-t-2 lg:border-t-0'>
          <Section className='flex flex-col gap-[44px] py-[64px] lg:py-[120px] transition-all'>
            <FadeIn delay={0.2} className='w-full'>
              <Text.H2>Call Us</Text.H2>
            </FadeIn>
            <div className='flex flex-row flex-wrap gap-[16px] w-full'>
              <ContactInfo index={1} title='Elder' phoneNumber='+971552997677'>
                M. V. Sunny
              </ContactInfo>
              <ContactInfo index={2} title='Elder' phoneNumber='+971507596932'>
                Sunil Philip
              </ContactInfo>
              <ContactInfo index={3} title='Deacon' phoneNumber='+971555268927'>
                Thomas Samuel
              </ContactInfo>
              <ContactInfo index={4} title='Deacon' phoneNumber='+971566932355'>
                Suresh Jacob
              </ContactInfo>
              <ContactInfo index={5} title='Deacon' phoneNumber='+971507288740'>
                Thomas Chandy
              </ContactInfo>
              <ContactInfo index={6} title='Deacon' phoneNumber='+971506454246'>
                Prasad Daniel
              </ContactInfo>
            </div>
          </Section>
        </div>
      </div>
    </Page>
  )
}
